import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import OnlyInSingleRoutineMode from '../../../SingleRoutineMode/OnlyInSingleRoutineMode';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import EDIconButton from '../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import { IDatabase } from '../../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';
import { APP_NAVBAR_HEIGHT_PX } from '../../../../BaseComponents/ThemeProvider/AvenyTheme';
interface IProps {
  activeDatabase?: IDatabase;
  setHelpDialogOpen: (open: boolean) => void;
  programLocationHeader: string;
  classes?: any;
}

const styles = (theme: Theme) => ({
  toolbarRight: {
    display: 'flex',
    flex: '1 1 0%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingLeft: theme.spacing(6),
    minHeight: APP_NAVBAR_HEIGHT_PX,
    [theme.breakpoints.down('sm')]: {
      flex: '0',
      justifySelf: 'flex-end',
      paddingLeft: 0,
    },
  },
});

const AppNavBarSmallToolbarBase: React.FC<
  React.PropsWithChildren<IProps>
> = props => (
  <>
    <OnlyInSingleRoutineMode>
      <EDTypography color="inherit" variant="body2">
        {props.activeDatabase?.name}
      </EDTypography>
    </OnlyInSingleRoutineMode>
    <div className={props.classes.toolbarRight}>
      {props.programLocationHeader && (
        <EDIconButton
          tooltip="Hjälp"
          color="inherit"
          onClick={() => props.setHelpDialogOpen(true)}
          icon={
            <EDIcon iconType="help_outline" color="inherit" size="medium" />
          }
          noLeftMargin
          margin="dense"
          noTopMargin
          noBottomMargin
        />
      )}
    </div>
  </>
);

export const AppNavBarSmallToolbar = withStyles(
  AppNavBarSmallToolbarBase,
  styles
);
